// extracted by mini-css-extract-plugin
export default {"login-button":"LoginButton_login-button__-tDdF"};